<template>
<div class="container-fluid d-flex flex-column h-100">
  <div class="bible-open-head">
    <b-button :variant="'light'">
      全て既読にする
    </b-button>
  </div>
  <b-list-group class="flex-grow-1 d-flex flex-column pb-3 overflow-y-s">
    <b-list-group-item href="#" class="flex-column align-items-start" v-for="item in items">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">{{ item.title }}</h5>
        <small>{{ moment(item.published_at).format("YYYY/MM/DD") }}</small>
      </div>
      <p class="mb-1" v-html="item.body">
      </p>
      <small>{{ item.category }}</small>
    </b-list-group-item>
  </b-list-group>
</div>
</template>

<script>
import moment from 'moment'

export default {
  data: function () {
    return {
      moment: moment,
      items: [
        { published_at: '2018-10-10T13:50:40+09:00', title: 'this is title 1.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-10-08T13:50:40+09:00', title: 'this is title 2.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-10-06T13:50:40+09:00', title: 'this is title 3.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-10-04T13:50:40+09:00', title: 'this is title 4.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-10-02T13:50:40+09:00', title: 'this is title 5.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-10-01T13:50:40+09:00', title: 'this is title 6.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-09-30T13:50:40+09:00', title: 'this is title 7.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-09-22T13:50:40+09:00', title: 'this is title 8.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-09-16T13:50:40+09:00', title: 'this is title 9.', body: '<p>hello! this is text.</p>', category: 'JBS', },
        { published_at: '2018-09-10T13:50:40+09:00', title: 'this is title 10.', body: '<p>hello! this is text.</p>', category: 'JBS', },
      ],
      index: {
        book: {
          value: 0,
          fields: [ 'name', ],
        },
        chapter: {
          value: 0,
          fields: [ 'name', ],
        },
        verse: {
          value: 0,
          fields: [ 'name', ],
        },
      },
    }
  },

  computed: {
    stickyTopBible: function () {
      return {
        'top': this.$parent.navbarHeight + 'px',
        'height': 'calc(100vh - ' + this.$parent.navbarHeight + 'px)',
        'overflow-y': 'scroll',
      }
    },
  },

  methods: {
  },

  created: function() {
  },

  beforeDestroy: function () {
  }
}
</script>

<style>
</style>
